export type BudgetsResponse = {
  items: Array<BudgetResponse>
  paging: {
    total: number
    page: number
    perPage: number
    pages: number
  }
}

type CycleConfiguration = {
  startDate: string
  endDate: string
  autoResetOnPeriodEnd: boolean
  carryOverBalance: boolean
}

type NotificationSettings = {
  enable: boolean
  thresholds?: Array<{
    type: 'PERCENT' | 'AMOUNT'
    value: number
  }>
  recipients?: Array<{
    type: 'Email'
    identifier: string
  }>
}

type LinkedEntity = {
  id: string
  type: 'ADDRESSES' | 'USERS' | 'PROMOTIONS' | 'ADS'
}

export type BudgetRequest = {
  PromotionId: string
  PromotionName: string
  Amount: number
  NotificationThresholds: number[]
  Emails: string[]
  StartDate: string
  EndDate: string
}

export type BudgetPayload = {
  name: string
  description: string
  amount: number
  cycleConfiguration: CycleConfiguration
  notificationSettings?: NotificationSettings
  allocations: AllocationPayload[]
}

export type AllocationPayload = {
  linkedEntity: LinkedEntity
  amount: number
  cycleConfiguration: CycleConfiguration
  notificationSettings?: NotificationSettings
}

export type AllocationResponse = Omit<AllocationPayload, 'amount'> & {
  id: string
  status: BudgetStatus
  balance: {
    amount: number
    balanceAdjustment: number
    remaining: number
  }
  notificationSettings: NotificationSettings
}

export type BudgetResponse = Omit<BudgetPayload, 'amount'> & {
  id: string
  allocations: AllocationResponse[]
  balance: {
    amount: number
    balanceAdjustment: number
    remaining: number
  }
  status: BudgetStatus
}

export type BudgetNotificationSettings = {
  enable: boolean
  thresholds: number[]
  emails: string[]
}

export const EMPTY_BUDGET_NOTIFICATION: BudgetNotificationSettings = {
  enable: false,
  thresholds: [],
  emails: [],
}

export type BaseBudget = {
  amount: number
  utilized: number
  status: BudgetStatus
  notification?: BudgetNotificationSettings
}

export type BudgetIds = {
  id: string
  allocationId: string
}

export type BudgetWithIds = BaseBudget & BudgetIds

export type Budget = BudgetWithIds | BaseBudget | BudgetIds

export enum BudgetStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}
